import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { ACCOUNT_PATH } from "utils/constants/paths";

const Account = Loadable(React.lazy(() => import("./View")));

export const AccountRoute: IRouteItem = {
  path: ACCOUNT_PATH,
  element: React.createElement(Account),
  name: "Account",
  showInDrawer: false,
};
